import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import { Pagination } from 'swiper/modules';

const RealApps = () => {
    // Function to detect device and redirect to appropriate app store
    const handleAppStoreClick = (appName) => {
        // Define app store URLs for each app
        const appUrls = {
            'Talent Lockr': {
                ios: 'https://apps.apple.com/us/app/talent-lockr/id6444275012',
                android: 'https://play.google.com/store/search?q=talentlockr&c=apps&hl=en'
            },
            'Bolt For Gold': {
                ios: '#',
                android: '#'
            },
            'Ibiza Only': {
                ios: 'https://apps.apple.com/au/app/ibiza-only/id6738636443',
                android: 'https://play.google.com/store/apps/details?id=io.everestapps.ibizaonly&hl=en'
            }
        };
        
        // Check if the app exists in our mapping
        if (!appUrls[appName]) {
            console.error(`No URLs defined for app: ${appName}`);
            return;
        }
        
        // Detect if user is on iOS
        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        
        // Detect if user is on Mac
        const isMac = /Mac/.test(navigator.userAgent);
        
        // Redirect to appropriate store based on device
        if (isIOS || isMac) {
            window.open(appUrls[appName].ios, '_blank');
        } else {
            window.open(appUrls[appName].android, '_blank');
        }
    };
    return (
        <div className="bg-radial-custom bg-opacity-20  relative text-white overflow-hidden flex flex-col justify-between py-8 md:px-24 px-4">
            <div className='text-3xl md:text-5xl lg:text-7xl text-center md:text-start'>
                <h2 className='text-primary'>Real Apps.</h2>
                <h2 className='text-white font-bold'>Real Results</h2>
            </div>

            <div className='hidden md:flex flex-col md:flex-row gap-16 mt-10 lg:mt-20 lg:gap-32'>
                <div className='flex flex-col gap-2 items-center lg:items-start'>
                    <img src="/assets/talent-lockr.jpg" alt="Talent lockr app" className='w-2/3 mx-auto md:w-full' />
                    <p className='text-center text-2xl lg:text-3xl font-semibold'>Talent Lockr</p>
                    <p className='text-center text-lg font-thin'>Athlete network for players, schools & scouts</p>
                    <img 
                        src="/assets/app-store.jpg" 
                        alt="App Store" 
                        className='w-28 md:w-36 mt-4 cursor-pointer' 
                        onClick={() => handleAppStoreClick('Talent Lockr')} 
                    />
                </div>
                <div className='flex flex-col gap-2 items-center lg:items-start'>
                    <img src="/assets/bolt-for-gold.jpg" alt="Talent lockr app" className='w-2/3 mx-auto md:w-full' />
                    <p className='text-center text-2xl lg:text-3xl font-semibold'>Bolt For Gold</p>
                    <p className='text-center text-lg font-thin'>International school & Charity running app</p>
                    <img 
                        src="/assets/app-store.jpg" 
                        alt="App Store" 
                        className='w-28 md:w-36 mt-4 cursor-pointer' 
                        onClick={() => handleAppStoreClick('Bolt For Gold')} 
                    />
                </div>
                <div className='flex flex-col gap-2 items-center lg:items-start'>
                    <img src="/assets/ibiza-only.jpg" alt="Talent lockr app" className='w-2/3 mx-auto md:w-full' />
                    <p className='text-center text-2xl lg:text-3xl font-semibold'>Ibiza Only</p>
                    <p className='text-center text-lg font-thin'>AI Concierge & Dating app for Ibiza</p>
                    <img 
                        src="/assets/app-store.jpg" 
                        alt="App Store" 
                        className='w-28 md:w-36 mt-4 cursor-pointer' 
                        onClick={() => handleAppStoreClick('Ibiza Only')} 
                    />
                </div>
            </div>

            <div className='py-8 md:hidden'>
                <Swiper
                    slidesPerView={1}
                    spaceBetween={0}
                    pagination={{
                        clickable: true,
                    }}
                    loop={true}
                    modules={[Pagination]}
                    className="mySwiper custom-swiper"
                >
                    <SwiperSlide>
                        <div className='flex flex-col gap-2 items-center lg:items-start'>
                            <img src="/assets/talent-lockr.jpg" alt="Talent lockr app" className='w-2/3 mx-auto md:w-full' />
                            <p className='text-center text-2xl lg:text-3xl font-semibold'>Talent Lockr</p>
                            <p className='text-center text-lg font-thin'>Athlete network for players, schools & scouts</p>
                            <img 
                                src="/assets/app-store.jpg" 
                                alt="App Store" 
                                className='w-28 md:w-36 mt-4 cursor-pointer' 
                                onClick={() => handleAppStoreClick('Talent Lockr')} 
                            />
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className='flex flex-col gap-2 items-center lg:items-start'>
                            <img src="/assets/bolt-for-gold.jpg" alt="Talent lockr app" className='w-2/3 mx-auto md:w-full' />
                            <p className='text-center text-2xl lg:text-3xl font-semibold'>Bolt For Gold</p>
                            <p className='text-center text-lg font-thin'>International school & Charity running app</p>
                            <img 
                                src="/assets/app-store.jpg" 
                                alt="App Store" 
                                className='w-28 md:w-36 mt-4 cursor-pointer' 
                                onClick={() => handleAppStoreClick('Bolt For Gold')} 
                            />
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className='flex flex-col gap-2 items-center lg:items-start'>
                            <img src="/assets/ibiza-only.jpg" alt="Talent lockr app" className='w-2/3 mx-auto md:w-full' />
                            <p className='text-center text-2xl lg:text-3xl font-semibold'>Ibiza Only</p>
                            <p className='text-center text-lg font-thin'>AI Concierge & Dating app for Ibiza</p>
                            <img 
                                src="/assets/app-store.jpg" 
                                alt="App Store" 
                                className='w-28 md:w-36 mt-4 cursor-pointer' 
                                onClick={() => handleAppStoreClick('Ibiza Only')} 
                            />
                        </div>
                    </SwiperSlide>
                </Swiper>
            </div>

        </div>
    )
}

export default RealApps